var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { memo, useState } from 'react';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { RedesignModalShell } from 'root/src/client/v2/common/components/RedesignModalShell';
import { useRedesignModal } from 'root/src/client/v2/common/contexts/redesignModal.context';
import { Button } from 'root/src/client/v2/common/components/ui/button';
import { Textarea } from 'root/src/client/v2/common/components/ui/textarea';
import { toast } from 'root/src/client/v2/common/components/ui/sonner';
import { getErrorMessage } from 'root/src/client/v2/common/hooks/useDareDropApi';
import { trpc } from 'root/src/client/v2/trpc/trpc';
// Redesign of the legacy RejectDareCardModal: reuses the same trpc.project.reject mutation, in the
// redesign modal shell. Reason is emailed to pledgers, so it stays optional but encouraged.
export const RedesignRejectDareModal = memo(({ projectUrl, onSuccess }) => {
    const { hide } = useRedesignModal();
    const [message, setMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const rejectMutation = trpc.project.reject.useMutation();
    const onConfirm = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsSubmitting(true);
        try {
            yield rejectMutation.mutateAsync({ projectUrl, message });
            toast.success('Dare rejected');
            yield (onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess());
            hide();
        }
        catch (err) {
            toast.error(getErrorMessage(err));
        }
        finally {
            setIsSubmitting(false);
        }
    });
    return (<RedesignModalShell className="sm:max-w-md">
			<div className="flex w-full flex-col items-center gap-3 text-center">
				<div className="flex h-12 w-12 items-center justify-center rounded-full border border-solid border-neon-pink/30 bg-neon-pink/10">
					<CancelOutlinedIcon sx={{ fontSize: 24 }} className="text-neon-pink"/>
				</div>
				<h2 className="font-display text-xl font-bold text-foreground">Reject dare</h2>
				<p className="text-sm text-muted-foreground">Let your pledgers know why you are rejecting this dare (optional).</p>
			</div>

			<Textarea value={message} onChange={event => setMessage(event.target.value)} maxLength={300} rows={4} placeholder="For example: it is too hard, or not a good fit right now." className="w-full resize-none"/>
			<span className="-mt-2 self-end text-[11px] text-muted-foreground">{message.length}/300</span>

			<div className="flex w-full gap-3">
				<Button variant="ghost" onClick={hide} className="flex-1 rounded-lg text-sm">Cancel</Button>
				<Button variant="destructive" loading={isSubmitting} onClick={onConfirm} className="flex-1 rounded-lg text-sm font-semibold">
					Reject dare
				</Button>
			</div>
		</RedesignModalShell>);
});
